import React from "react";
import "./Navbar.css";
import {Nav, NavLink, NavMenu, HamburgerMenu, Dropdown, LogoutButton, Overlay} from "./NavbarElements";
import { useNavigate } from 'react-router-dom'
import { useAuth } from "../../hooks/useAuth.js";

const Navbar = () => {
    // This whole logging out business can be moved; I just stuck it here temporarily
    const navigate = useNavigate()
    const { logout } = useAuth() // get logout function from useAuth()
    const isLoggedIn = localStorage.getItem('uid') !== null;
    const submitLogout = async(e) => {
        const logoutSuccess = await logout() // Log the user out and redirect them to information page
        if (logoutSuccess) {
            navigate('/information')
            setIsOpen(false);
        } else {
            console.log('logout error')
        }
    }

    // Hamburger Menu
    const [isOpen, setIsOpen] = React.useState(false);
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };
    
    const closeMenu = () => {
        setIsOpen(false);
    };

    // Close mobile menu when window is resized past mobile breakpoint
    React.useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 767 && isOpen) {
                setIsOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isOpen]);

    return (
            <>
            <Nav>
                <NavMenu>
                    <NavLink to="/"> Chat With Us </NavLink>
                    <NavLink to="/information"> Information </NavLink>
                    <NavLink to="/faq"> FAQ </NavLink>
                    <NavLink to="/help"> Help </NavLink>
                    <NavLink to="/about"> Team </NavLink>
                    {isLoggedIn && (
                        <LogoutButton onClick={submitLogout}> Logout </LogoutButton>
                    )}
                </NavMenu>

                <HamburgerMenu onClick={toggleMenu}>
                    {isOpen ? '✕' : '☰'}
                </HamburgerMenu>
            </Nav>
            
            {isOpen && (
                <>
                    <Overlay onClick={closeMenu} />
                    <Dropdown>
                        <NavLink to="/" onClick={closeMenu}> Chat With Us </NavLink>
                        <NavLink to="/information" onClick={closeMenu}> Information </NavLink>
                        <NavLink to="/faq" onClick={closeMenu}> FAQ </NavLink>
                        <NavLink to="/help" onClick={closeMenu}> Help </NavLink>
                        <NavLink to="/about" onClick={closeMenu}> Team </NavLink>
                        {isLoggedIn && (
                            <LogoutButton onClick={submitLogout}> Logout </LogoutButton>
                        )}
                    </Dropdown>
                </>
            )}
            </>
    );
};

export default Navbar;